import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { I18nProvider } from './i18n/I18nContext';
import { registerServiceWorker } from './pwa/register';
import { ensurePersistentStorage } from './db/storage';
import './styles.css';

registerServiceWorker();
// Opt the origin out of automatic eviction so a full SD card / quota pressure
// can't silently wipe the device token + downloaded content.
void ensurePersistentStorage();

const rootEl = document.getElementById('root');
if (rootEl) {
  createRoot(rootEl).render(
    <StrictMode>
      <I18nProvider>
        <App />
      </I18nProvider>
    </StrictMode>,
  );
}
